import { useContext, useReducer } from "react";
import { Outlet } from "react-router-dom";
import { sponsorReducer } from "./sponsorReducer";
import { sponsorInitialState } from "./sponsorInitialState";
import SponsorContext from "./SponsorContext";


export const useSponsorContext = () => useContext(SponsorContext)


export function SponsorProvider() {
    const [sponsorState, sponsorDispatch] = useReducer(
        sponsorReducer,
        sponsorInitialState
    )

    return (
        <SponsorContext.Provider value={{ sponsorState, sponsorDispatch }}>
            <Outlet />
        </SponsorContext.Provider>
    )
}
